import { getText, encode } from '../helpers';

const text = getText('pages.dataVendor');
const ratText = getText('pages.requestTrial');
const coalText = getText('pages.requestTrial');

function constructVendorEmail(formData: DataVendorState) {
    let regionData = '';
    text.region.options.forEach((element: AnonymousObject) => {
        if (formData.region[element.id]) {
            regionData += `<li>${element.text}</li>`;
        }
    });

    const data = `<div id='initialText'><p>${text.initialText}</p></div>
    <div id="${text.vendorName.name}">${text.vendorName.text}: <p>${formData.vendorName}</p></div>
    <div id="${text.contactName.name}">${text.contactName.text}:<p>${formData.contactName}</p></div>
    <div id="${text.phone.name}">${text.phone.text}: <p>${formData.phone}</p></div>
    <div id="${text.email.name}">${text.email.text}: <p>${formData.email}</p></div>
    <div id="${text.productDescription.name}">${text.productDescription.title}<p>${formData.productDescription}</p></div>
    <div id="${text.dataCollection.name}">${text.dataCollection.title}<p>${formData.dataCollection}</p></div>
    <div id="${text.dataHistory.name}">${text.dataHistory.title}<p>${formData.dataHistory}</p></div>
    <div id="${text.pointInTime.name}">${text.pointInTime.title}<p>${formData.pointInTime}</p></div>
    <div id="${text.frequency.name}">${text.frequency.title}<p>${formData.frequency}</p></div>
    <div id="${text.numOfCompanies.name}">${text.numOfCompanies.title}<p>${formData.numOfCompanies}</p></div>
    <div id="${text.region.name}">${text.region.title}<p><ul>${regionData}</ul></p><br/></div>
    <div id="${text.linkages.name}">${text.linkages.title}<p>${formData.linkages}</p></div>
    <div id="${text.useCases.name}">${text.useCases.title}<p>${formData.useCases}</p></div>
    <div id="${text.competitors.name}">${text.competitors.title}<p>${formData.competitors}</p></div>
    `;

    const emailBody = text.emailTemplate.replace('@@DATA', data);
    return encode(emailBody);
}

// function constructRATEmail(productName: string, formData: RequestATrialState) {
//     const data = `
//     <div id="${ratText.firstName.name}"><p><b>${ratText.firstName.text}</b>: ${formData.FirstName}</p></div>
//     <div id="${ratText.lastName.name}"><p><b>${ratText.lastName.text}</b>: ${formData.LastName}</p></div>
//     <div id="${ratText.phone.name}"><p><b>${ratText.phone.text}</b>: ${formData.Phone}</p></div>
//     <div id="${ratText.email.name}"><p><b>${ratText.email.text}</b>: ${formData.Email}</p></div>
//     <div id="${ratText.city.name}"><p><b>${ratText.city.text}</b>: ${formData.City}</p></div>
//     <div id="${ratText.country.name}"><p><b>${ratText.country.text}</b>: ${formData.Country}</p></div>
//     <div id="${ratText.postalCode.name}"><p><b>${ratText.postalCode.text}</b>: ${formData.PostalCode}</p></div>
//     <div id="${ratText.companyName.name}"><p><b>${ratText.companyName.text}</b>: ${formData.Company}</p></div>
//     <div id="${ratText.companyType.name}"><p><b>${ratText.companyType.text}</b>: ${formData.CompanyType}</p></div>
//     <div id="${ratText.jobFunction.name}"><p><b>${ratText.jobFunction.text}</b>: ${formData.JobFunction}</p></div>
//     ${formData.State ? `<div id="${ratText.companyState.name}"><p><b>${ratText.companyState.text}</b>: ${formData.State}</p></div>` : ''}
//     <div id="${ratText.tellUsSectionTitle}"><p><b>${ratText.tellUsSectionTitle}</b>: ${formData.OtherInterest}</p></div>
//     <div id="${ratText.interestSectionTitle}"><p><b>${ratText.interestSectionTitle}</b>: ${productName} </p></div>
//     ${formData.HasUserConsent ? `<div id="${ratText.subscription.name}"><p>${ratText.subscription.text} </p></div>` : ''}
//     `;

//     let emailBody = ratText.emailTemplate.replace('@@DATA', data);
//     emailBody = emailBody.replace('{productName}', productName);

//     return encode(emailBody);
// }
function constructRATEmail(productName: string, formData: RequestATrialState) {

    const data = `
    <div id="${ratText.firstName.name}"><p><b>${ratText.firstName.text}</b>: ${formData.FirstName}</p></div>
    <div id="${ratText.lastName.name}"><p><b>${ratText.lastName.text}</b>: ${formData.LastName}</p></div>
    <div id="${ratText.phone.name}"><p><b>${ratText.phone.text}</b>: ${formData.Phone}</p></div>
    <div id="${ratText.email.name}"><p><b>${ratText.email.text}</b>: ${formData.Email}</p></div>
    <div id="${ratText.city.name}"><p><b>${ratText.city.text}</b>: ${formData.City}</p></div>
    <div id="${ratText.country.name}"><p><b>${ratText.country.text}</b>: ${formData.Country}</p></div>
     ${formData.PostalCode ? `<div id="${ratText.postalCode.name}"><p><b>${ratText.postalCode.text}</b>: ${formData.PostalCode}</p></div>` : ''}
    <div id="${ratText.companyName.name}"><p><b>${ratText.companyName.text}</b>: ${formData.Company}</p></div>
    <div id="${ratText.companyType.name}"><p><b>${ratText.companyType.text}</b>: ${formData.CompanyType}</p></div>
    <div id="${ratText.jobFunction.name}"><p><b>${ratText.jobFunction.text}</b>: ${formData.JobFunction}</p></div>
    ${formData.State ? `<div id="${ratText.companyState.name}"><p><b>${ratText.companyState.text}</b>: ${formData.State}</p></div>` : ''}
    ${formData.CompanyCountry ? `<div id="${ratText.companyCountry.name}"><p><b>${ratText.companyCountry.text}</b>: ${formData.CompanyCountry}</p></div>` : ''}
    <div id="${ratText.tellUsSectionTitle}"><p><b>${ratText.tellUsSectionTitle}</b>: ${formData.OtherInterest}</p></div>
    <div id="${ratText.interestSectionTitle}"><p><b>${ratText.interestSectionTitle}</b>: ${formData.InterestArea} </p></div>
    ${formData.HasUserConsent ? `<div id="${ratText.subscription.name}"><p>${ratText.subscription.text} </p></div>` : ''}
    `;

    let emailBody = ratText.emailTemplate.replace('@@DATA', data);
    emailBody = emailBody.replace('{productName}', productName);

    return encode(emailBody);
}


function constructCoalitionRATEmail(productName: string, formData: RequestATrialState) {
    const data = `
    <div id="${coalText.firstName.name}"><p><b>${coalText.firstName.text}</b>: ${formData.FirstName}</p></div>
    <div id="${coalText.lastName.name}"><p><b>${coalText.lastName.text}</b>: ${formData.LastName}</p></div>
    <div id="${coalText.phone.name}"><p><b>${coalText.phone.text}</b>: ${formData.Phone}</p></div>
    <div id="${coalText.email.name}"><p><b>${coalText.email.text}</b>: ${formData.Email}</p></div>
    <div id="${coalText.city.name}"><p><b>${coalText.city.text}</b>: ${formData.City}</p></div>
    <div id="${coalText.companyName.name}"><p><b>${coalText.companyName.text}</b>: ${formData.Company}</p></div>
    <div id="${coalText.companyType.name}"><p><b>${coalText.companyType.text}</b>: ${formData.CompanyType}</p></div>
    <div id="${coalText.country.name}"><p><b>${coalText.country.text}</b>: ${formData.Country}</p></div>
    <div id="${coalText.jobFunction.name}"><p><b>${coalText.jobFunction.text}</b>: ${formData.JobFunction}</p></div>
    <div id="${coalText.tellUsSectionTitle}"><p><b>${coalText.tellUsSectionTitle}</b>: ${formData.OtherInterest}</p></div>
    <div id="${coalText.interestSectionTitle}"><p><b>${coalText.interestSectionTitle}</b>: ${formData.InterestArea} </p></div>
     ${formData.HasUserConsent ? `<div id="${ratText.subscription.name}"><p>${ratText.subscription.text} </p></div>` : ''}
    `;

    let emailBody = coalText.emailTemplate.replace('@@DATA', data);
    emailBody = emailBody.replace('{productName}', productName);

    return encode(emailBody);
}

export { constructVendorEmail as default, constructRATEmail, constructCoalitionRATEmail };
